import { useState } from "react";

export const useTableSort = (
  defaultSortBy: string,
  defaultSortOrder: -1 | 1 = -1,
) => {
  const [sortOrder, setSortOrder] = useState(defaultSortOrder);
  const [sortBy, setSortBy] = useState(defaultSortBy);

  const requestSort = (key: string) => {
    if (key === sortBy) {
      setSortOrder((state) => (state === -1 ? 1 : -1));
    } else {
      setSortBy(key);
      setSortOrder(defaultSortOrder);
    }
  };
  return { sortBy, sortOrder, requestSort };
};
